import { defineMessages } from 'react-intl';

const scope = 'app.containers.shared.SimpleReportFilters';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Filters',
    },
    periodSelectionLabel: {
        id: `${scope}.periodSelectionLabel`,
        defaultMessage: 'Please choose the period you would like to display:',
    },
    choosePeriodButton: {
        id: `${scope}.choosePeriodButton`,
        defaultMessage: 'Choose a period',
    },
    changePeriodButton: {
        id: `${scope}.changePeriodButton`,
        defaultMessage: 'Change',
    },
    getDataButton: {
        id: `${scope}.getDataButton`,
        defaultMessage: 'Get my data',
    },
});
